export default "__VITE_ASSET__DCHKOwLc__"